import { render } from "./ProposOnDemandAssessmentalPending.vue?vue&type=template&id=3e1c1e20&scoped=true"
import script from "./ProposOnDemandAssessmentalPending.vue?vue&type=script&lang=js"
export * from "./ProposOnDemandAssessmentalPending.vue?vue&type=script&lang=js"

import "./ProposOnDemandAssessmentalPending.vue?vue&type=style&index=0&id=3e1c1e20&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e1c1e20"]])

export default __exports__